import {
    FETCH_PAYERS_REQUEST, FETCH_PAYERS_SUCCESS, FETCH_PAYERS_FAILURE,
    CREATE_PAYER_SUCCESS, UPDATE_PAYER_SUCCESS, DELETE_PAYER_SUCCESS
  } from '../actions/payerActions';
  
  const initialState = {
    payers: [],
    loading: false,
    error: null,
  };
  
  export default function payerReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_PAYERS_REQUEST:
        return { ...state, loading: true };
      case FETCH_PAYERS_SUCCESS:
        return { ...state, loading: false, payers: action.payload };
      case CREATE_PAYER_SUCCESS:
        return { ...state, payers: [...state.payers, action.payload] };
      case UPDATE_PAYER_SUCCESS:
        return {
          ...state,
          payers: state.payers.map((p) => (p.id === action.payload.id ? action.payload : p)),
        };
      case DELETE_PAYER_SUCCESS:
        return {
          ...state,
          payers: state.payers.filter((p) => p.id !== action.payload),
        };
      default:
        return state;
    }
  }
  